"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ArbitrumRelayerFee_1 = require("./ArbitrumRelayerFee");
const ethers_1 = require("ethers");
const models_1 = require("../models");
const constants_1 = require("../constants");
const RelayerFees = {
    [models_1.Chain.Arbitrum.slug]: ArbitrumRelayerFee_1.ArbitrumRelayerFee,
    [models_1.Chain.Nova.slug]: ArbitrumRelayerFee_1.ArbitrumRelayerFee
};
class RelayerFee {
    async getRelayCost(network, chainSlug, token) {
        // Relayer fees shouldn't be calculated for non-mainnet chains since some fee calculations rely on chain-specific data
        // that is less useful on testnets. Instead, we use a default value for testnets.
        if (network !== constants_1.NetworkSlug.Mainnet) {
            if (token === 'ETH') {
                return ethers_1.BigNumber.from(0);
            }
            else {
                return ethers_1.BigNumber.from('0');
            }
        }
        if (!RelayerFees[chainSlug]) {
            return ethers_1.BigNumber.from(0);
        }
        return ethers_1.BigNumber.from(0);
    }
}
exports.default = RelayerFee;
